import type { ShiftDto, ShiftGridItemDto, ShiftInputDto, ShiftPagedRequestDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class ShiftService {
  apiName = 'Default';
  

  createShiftByInputDto = (inputDto: ShiftInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/shift/shift',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  deleteShiftByShiftId = (shiftId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/shift/shift/${shiftId}`,
    },
    { apiName: this.apiName,...config });
  

  editShiftByInputDto = (inputDto: ShiftInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/shift/edit-shift',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  getAllShiftsByInput = (input: ShiftPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ShiftGridItemDto>>({
      method: 'GET',
      url: '/api/app/shift/shifts',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getShiftByShiftId = (shiftId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ShiftDto>({
      method: 'GET',
      url: `/api/app/shift/shift/${shiftId}`,
    },
    { apiName: this.apiName,...config });
  

  getShiftsToSelect = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ShiftDto[]>({
      method: 'GET',
      url: '/api/app/shift/shifts-to-select',
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
